Property_list = {
	p_initialised : false
	,
	init : function()
	{
		// Initialise ajax procedures.
		//Property_list.setup_ajax();
		
		// Run list setup procedures.
		Property_list.setup_list();
		
		// Track whether list has been initilised.
		Property_list.p_initialised = true;
	}
	,
	setup_list : function()
	{		
		// Default list: Make property list wrapper elements the same height.
		//jQuery('.view.default .property-list .content').matchHeight({
		//    byRow: true,
		//    property: 'height',
		//    target: null,
		//    remove: false
		//});
		
		// Add URL parameter to property links. Pass on search parameters to property detail page.
		jQuery('.property-list .property-link').each(function(){
			
			// Get current URL URI instance.
			var uri = new URI();
			
			// Get query string.
			var query = uri.search(); // String
			
			// Check if we have a query in the URL.
			if( query.length > 0 )
			{
				// Get query data.
				var query_data = uri.search(true); // Object
				
				// Get attributes.
				var check_in = query_data.arrival;
				var check_out = query_data.departure;
				var sleeps_min = query_data.sleeps_min;
				
				// Assemble link for each property and include query.
				var link = jQuery(this).attr('href');
				var property_link = link + query;
				//jQuery(this).attr('href',property_link);
			}
			
			// Setup click functionality.
			/*
			jQuery(this).click(function(event){
				// Show global content loader.
				console.log('PROPERTY CLICK');
				OC__Content_loader.show_page_loader();
			});
			*/
		});
		
	}
	,
	setup_ajax : function( pm_options )
	{
		// Check whether we have first run on the property list.
		if( !Property_list.p_initialised )
		{
			// Check if any property list elements should load with ajax.
			jQuery( '.properties[data-sh-ajax-load="1"], .properties[data-sh-ajax-load="true"]' ).each(function(){
				
				var options = {};
				options.property_list = jQuery(this);
				Property_list.load_list(options);
				
			});
		}
		
		// Check if any property list elements on page should be setup for ajax.
		jQuery('.properties[data-sh-ajax-setup="1"], .properties[data-sh-ajax-setup="true"]').each(function(){
			
			// Look for pagination AJAX setup.
			if( jQuery(this).attr('data-sh-modules') == 'pagination' )
			{	
				// Get the type of pagination. Replace (default) or add.
				var pagination_type = jQuery(this).attr('data-sh-pagination-type');
				
				jQuery(this).find('li').each(function(pm_index){
					
					var page_number = jQuery(this).attr('data-page-number');
					
					jQuery(this).find('a').each(function(event){
						
						jQuery(this).attr('href','#property-list');
						
						jQuery(this).click(function(event){
							
							var options = {};
							options.page_number = page_number;
							options.pagination_type = pagination_type;
							jQuery('.properties[data-sh-ajax-update="1"]').trigger('sh_load_property_list',options);
							
							event.preventDefault();
						});
						
					});
					
				});
				
			}
			
		});
		
		// Look for page elements that want to update via AJAX upon receiving appropriate events.
		if( !Property_list.p_initialised )
		{	
			jQuery( '.properties[data-sh-ajax-update="1"], .properties[data-sh-ajax-update="true"]' ).each(function(pm_index){
				
				var module_type = jQuery(this).attr('data-sh-modules');
				
				//define a custom event listener
				jQuery(this).on('sh_load_property_list',function(event,pm_options){
					
					var pager_links = jQuery(this).find()
					
					var options = {};
					options.property_list = jQuery(this);
					options.page_number = pm_options.page_number;
					options.pagination_type = pm_options.pagination_type;
					console.log('HELLO', module_type, options);
					Property_list.load_list(options);
					
					if( module_type == 'pagination' )
					{
						
					}
					
	    		});
				
			});
		}
	}
	,
	load_list : function( pm_options )
	{
		// Get service path to retrieve property list HTML.
		var request_url = oc__oncloud_settings.url + 'library/property/services/property-list-html.php';
		
		// Assemble options for property list.
		var options = {};
		options.modules = pm_options.property_list.attr('data-sh-modules');
		options.views = pm_options.property_list.attr('data-sh-views');
		options.page_number = ( pm_options.page_number ) ? pm_options.page_number : 1;
		options.list_view = pm_options.property_list.attr('data-sh-list-view');
		options.pagination_type = pm_options.pagination_type;
		options.pagination_next_label = pm_options.property_list.attr('data-sh-pagination-next-label');
		options.properties_per_page = pm_options.property_list.attr('data-sh-properties-per-page');
		
		// Get the query from the current URL to pass on parameters.
		var uri = new URI();
		var query = uri.query();
		options.query = query;
		
		// For add pagination type we want a cumulative list of properties.
		if( pm_options.pagination_type == 'add' )
		{
			if( options.modules == 'list' && options.views == 'map' )
			{
				//var properties_per_page = 
				//options.properties_per_page = 
				//options.page_number = 1;
			}
		}
		
		// Insert loading styles while waiting for AJAX.
		var load_html = '<div class="load-icon-wrapper"><div class="load-icon"></div></div>';
		if( pm_options.pagination_type == 'add' ) // Adding to existing list.
		{
			/*
			// We want to add properties to the main list and nothing else.
			if( options.modules == 'list' && options.views != 'map' )
			{
				load_html = '<li class="loading">' + load_html + '</li>';
				pm_options.property_list.find('.property-list').append(load_html);
			}
			else // Every other module just gets replaced.
			{
				pm_options.property_list.addClass('loading').html(load_html);
			}			
			*/
		}
		else // Replacing existing list.
		{
			pm_options.property_list.addClass('loading').html(load_html);
		}
		
		console.log( 'CALL!', pm_options, options );
		
		jQuery.ajax({
	    	type: "POST",
	        url: request_url,
	        dataType: "html",
	        data: JSON.stringify( options ),
	        success: function( data, status, jqXHR ){
		        
		        
		        // Get HTML content.
		        var html_content = '';
				if( pm_options.pagination_type == 'add' ) // Adding to existing list.
				{
					/*
					html_content = jQuery(data);
					
					// We want to add properties to the main list and nothing else.
					if( options.modules == 'list' && options.views != 'map' )
					{
						// Extract just list items from returned HTML.
						var list_items = html_content.find('.property-list li.property');
						
						// Add new properties and remove loading element.
						pm_options.property_list.find('.property-list').append(list_items).find('.loading').remove();
					}
					else // Every other module just gets replaced.
					{
						// Get HTML without surrounding div.
						html_content = jQuery(data);
						html_content = html_content.children().unwrap();
						
						// Load HTML and remove loading styles.
						pm_options.property_list.html(html_content).removeClass('loading');
					}
					*/
				}
				else // Replacing existing list.
				{
					// Get HTML without surrounding div.
					html_content = jQuery(data);
					html_content = html_content.children().unwrap();
					
					// Load HTML and remove loading styles.
					pm_options.property_list.html(html_content).removeClass('loading');
				}
	            
	            // Re-initialise ajax procedures.
				Property_list.setup_ajax();
	            
	            // Re-run list setup procedures.
				Property_list.setup_list();
				
				// Run maps setup for map view.
				Maps.init();
				Maps_embedded.init();
            }
	    });
	    
	}
};


jQuery(document).ready(function(jQuery){
	
	/*
	* sh__site_object = global object loaded via WordPress.
	*/
	
	// Initialise property list.
	Property_list.init();
	
});


/*
	Get GET parameters from query string.
	https://stackoverflow.com/questions/979975/how-to-get-the-value-from-the-get-parameters
*/
function sh_parse_query_string(query)
{
	
	var vars = query.split("&");
	var query_string = {};
	for (var i = 0; i < vars.length; i++)
	{
		var pair = vars[i].split("=");
		// If first entry with this name
		if (typeof query_string[pair[0]] === "undefined")
		{
			query_string[pair[0]] = decodeURIComponent(pair[1]);
		// If second entry with this name
    	}
    	else if (typeof query_string[pair[0]] === "string")
    	{
			var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
			query_string[pair[0]] = arr;
		// If third or later entry with this name
		}
		else
		{
			query_string[pair[0]].push(decodeURIComponent(pair[1]));
		}
	}
	
	return query_string;
	
}